import './App.css';
import "./i18n";
import { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider }  from './context/AuthContext';
import { ThemeModeProvider, useThemeMode } from './context/ThemeModeContext';
import Routers from './route/Index';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { getTheme } from './theme';
import { ptBR, enUS } from '@mui/x-data-grid/locales';
import { useTranslation } from 'react-i18next';

const GRID_LOCALES = { pt: ptBR, en: enUS };

function ThemedApp() {
  const { i18n } = useTranslation();
  const { mode } = useThemeMode();
  const theme = useMemo(
    () => getTheme(mode, GRID_LOCALES[i18n.language] ?? ptBR),
    [mode, i18n.language]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <Routers />
          </AuthProvider>
        </BrowserRouter>
        <div className="global-overlay"></div>
      </div>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <ThemedApp />
    </ThemeModeProvider>
  );
}

export default App;
